import { decodeResourceIdFromUrl } from 'app/shared/utils/urlUtils';
import filterUtils from 'app/shared/utils/filterUtils';
import isEmpty from 'lodash/isEmpty';
import { loadFilterFromUrl } from 'app/shared/flux/actions/FilterActions';
import {
  getMarketTrends,
  getMedianRentByBedroom,
  getUnfilteredMarketTrends,
} from 'app/shared/flux/actions/AreaActions';
import { logError } from '@zg-rentals/log-error';

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;
  const state = store.getState();
  const pathname = state.router.location.pathname;
  const resourceId = decodeResourceIdFromUrl(pathname);
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToApiParams(queryString);
  const hasFilters = !isEmpty(queryObject);
  dispatch(loadFilterFromUrl(queryObject));

  dispatch(getMedianRentByBedroom(resourceId)).catch((err) => {
    logError({
      error: err,
      errorType: 'MarketTrends',
      context: {
        details: 'Market Stats Results Page: Error fetching Median Rent by Bedroom (SSR)',
        root: 'pages/MarketTrendsResultsPage#serverRouteWillMount',
      },
    });
  });

  if (hasFilters) {
    dispatch(getUnfilteredMarketTrends(resourceId))
      // @ts-ignore
      .catch((err) => {
        logError({
          error: err,
          errorType: 'MarketTrends',
          context: {
            details: 'Market Stats Results Page: Error fetching Unfiltered Market Stats (SSR)',
            root: 'pages/MarketTrendsResultsPage#serverRouteWillMount',
          },
        });
      });
  }

  return (
    dispatch(getMarketTrends({ ...filterParams, resourceId }))
      // @ts-ignore
      .catch((err) => {
        logError({
          error: err,
          errorType: 'MarketTrends',
          context: {
            details: 'Market Stats Results Page: Error fetching Market Stats (SSR)',
            root: 'pages/MarketTrendsResultsPage#serverRouteWillMount',
          },
        });

        return { changeHttpStatus: 404 };
      })
  );
};

export default serverRouteWillMount;
